/* eslint-disable prefer-template */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Grid,
  Paper,
  Tabs,
  Tab,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button
} from '@mui/material';
import { useFieldById } from '../../components/api/queries/hooks';
import {
  Header,
  Map,
  SizeOfPolygon,
  ListDetails
} from '../../components/rancherDashboardComponents/fieldFarmerDetails';
// import { ranchApi } from '../../components/api'
import { CircularProgessBm } from '../../components/@material-extend';
import { DocumentCards, ViewQuestion } from '../../components/rancherDashboardComponents';
import { useUpdateFieldStatus } from '../../components/api/mutations/hooks';

const statusList = ['UNCONFIRMED', 'CONFIRMED', 'REWORK'];
export const RanchDetail = () => {
  const [data, setData] = useState({});
  // const [coor, setCoor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState('All Details');
  // const urlQuery = new URLSearchParams(window.location.search);
  const [selectedStatus, setSelectedStatus] = useState('none');
  const [comments, setComments] = useState('');
  const [showSaveButton, setShowSaveButton] = useState(false);
  const { readonly } = useSelector((store) => store.userRoot.user);
  const navigate = useNavigate();

  const { state = {} } = useLocation();

  const { mutate, isPending } = useUpdateFieldStatus();

  const onSaveStatus = async () => {
    try {
      mutate({
        fieldId: state?.id,
        status: selectedStatus,
        producerId: state?.producerId
      });
      // await ranchApi.post('/editRanch', {
      //   PK: "rancher#" + urlQuery.get('rid'),
      //   SK: "ranch#" + urlQuery.get('id'),
      //   status: selectedStatus,
      //   comments
      // });
      // setData({ ...data, status: selectedStatus, comments });
    } catch (error) {
      alert(error);
    }
  };

  const onAddDocuments = () => {
    navigate(`../documents?TotalDoc=${data.TotalDoc || 0}`, {
      state: {
        fieldId: state.id,
        SK: state.producerId,
        // status: data.status,
        rowData: state?.rowData
      }
    });
  };
  const onEditRanch = () => {
    navigate('../AddRanch', {
      state: fieldData
    });
  };

  const { data: fieldData } = useFieldById({
    id: state?.id,
    producerId: state?.producerId,
    partnerId: state?.partnerId
  });
  const { userDetail, fieldDetails } = fieldData || {};
  const isConfirmedField = fieldDetails?.status === 'CONFIRMED';
  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const query = `?id=${urlQuery.get('id')}&rancherid=${urlQuery.get('rid')}`;
  //     const { data } = await ranchApi.get(`/getRanchById${query}`);
  //     console.log(data);
  //     delete data.userDetails.status
  //     setSelectedStatus(data?.ranchDetails.status)
  //     setData({ ...data.userDetails, ...data.ranchDetails });
  //     setCoor(JSON.parse(data.ranchDetails.coordinates));
  //     setSelectedStatus(data.ranchDetails?.status)
  //     setComments(data.comments || "");
  //   } catch (error) {
  //     console.log(error);
  //     alert('failed');
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  useEffect(() => {
    setSelectedStatus(fieldDetails?.status);
  }, [fieldDetails]);

  if (loading) {
    return (
      <CircularProgessBm
        sx={{
          height: '100vh'
        }}
      />
    );
  }

  const coor = fieldDetails?.coordinates?.[0] || [];
  const renderBody = {
    'All Details': (
      <Grid item xs={9}>
        <Map coor={[coor]} height="57vh" label="Ranch Polygon" />
        <Paper
          elevation={10}
          sx={{
            padding: '1rem',
            marginTop: '0.5rem',
            width: '100%'
          }}
        >
          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              margin: '1rem auto'
            }}
          >
            Documents
          </Typography>
          <DocumentCards data={fieldDetails} />
        </Paper>
        <Paper
          elevation={10}
          sx={{
            padding: '1rem',
            marginTop: '0.5rem',
            width: '100%'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              margin: '1rem auto'
            }}
          >
            Questionnaire (Status: {fieldDetails?.questionnaireStatus})
          </Typography>
          <ViewQuestion data={fieldData} />
        </Paper>
        {/* <Paper
        elevation={10}
        sx={{
          padding: '1rem',
          marginTop: '0.5rem',
          width: '100%'
        }}
      >
        <Typography variant="h6" marginBottom={3}>Comments</Typography>
        <Typography variant="p">
          {data.comments || "No comments"}
        </Typography>
        {data.partnerComments ?
          <>
            <Typography variant="h6" marginBottom={3}>Partner Comments</Typography>
            <Typography variant="p">
              {data.partnerComments || "No comments"}
            </Typography>
          </> : null
        }
        <TextField
          fullWidth
          multiline
          rows={5}
          style={{ marginTop: '2rem' }}
          onChange={({ target }) => setComments(target.value)}
          value={comments || ''} />
        <LoadingButton 
        loading={isPending} 
        // onClick={onSaveStatus}
         variant="contained" style={{
          backgroundColor: readonly ? "" : "#00AB55",
          margin: "0.5rem 0.5rem",
          marginTop: '2rem',
        }}
        disabled={readonly}
        >
          Save
        </LoadingButton>
      </Paper> */}
      </Grid>
    )
  };

  const onChange = (value) => {
    setSelectedStatus(value);
    setShowSaveButton(true);
  };
  
  return (
    <>
      {!loading && (
        <Grid
          spacing={1}
          container
          sx={{
            margin: '2rem auto',
            marginTop: '1rem',
            width: '85vw',
            paddingBottom: '2rem'
          }}
        >
          <Grid item xs={12}>
            <Header
              name={`${userDetail?.givenName} ${userDetail?.familyName}, ${fieldDetails?.fieldName}`}
              status={fieldDetails?.status}
            />
            <Paper elevation={10} sx={{ width: '100%', bgcolor: '#F4F6F8', display: 'flex' }}>
              <div style={{ flex: 1 }} />
              <Tabs
                value={tabs}
                onChange={(_, v) => {
                  setTabs(v);
                }}
              >
                {['All Details'].map((ele) => (
                  <Tab label={ele} key={ele} value={ele} />
                ))}
              </Tabs>
            </Paper>
          </Grid>
          <Grid item xs={12} container spacing={1}>
            <Grid item container xs={3} maxHeight="75vh">
              <Grid item xs={12}>
                <SizeOfPolygon
                  calculatedAcres={
                    fieldDetails?.unit === 'hectare'
                      ? (fieldDetails?.calculatedArea * 2.47).toFixed(0)
                      : fieldDetails?.calculatedArea
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ListDetails
                  header="Ranch Details"
                  keyValue={{
                    Country: fieldDetails?.country,
                    State: fieldDetails?.state,
                    'Ranch Address': fieldDetails?.address,
                    city: fieldDetails?.city,
                    postal: fieldDetails?.postal,
                    Mobile: fieldDetails?.phone_number
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ListDetails
                  header="Partner Details"
                  keyValue={{
                    // Project: userDetail?.projectId,
                    Partner: userDetail?.oldPartnerId
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ListDetails
                  keyValue={{
                    'Onboarded on': new Date(fieldDetails?.createdAt).toDateString().slice(4),
                    'Status Updated on': new Date(fieldDetails?.updatedAt).toDateString().slice(4)
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Paper
                  elevation={10}
                  sx={{
                    padding: '1rem',
                    marginTop: '0.5rem',
                    width: '100%'
                  }}
                >
                  <Typography variant="h6">Status</Typography>
                  <Box sx={{ minWidth: 120, marginTop: 3 }}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={selectedStatus}
                        label="Partner"
                        onChange={(event) => {
                          onChange(event.target.value);
                        }}
                        disabled={isConfirmedField}
                      >
                        <MenuItem key="all" value="none">
                          Select Status
                        </MenuItem>
                        {statusList.map((ele, index) => (
                          <MenuItem key={index} value={ele}>
                            {ele}
                          </MenuItem>
                        ))}
                      </Select>
                      {showSaveButton || !isConfirmedField ? (
                        <LoadingButton
                          loading={isPending}
                          onClick={onSaveStatus}
                          variant="contained"
                          style={{
                            backgroundColor: '#00AB55',
                            margin: '0.5rem 0.5rem'
                          }}
                        >
                          Save
                        </LoadingButton>
                      ) : null}
                    </FormControl>
                  </Box>
                </Paper>
              </Grid>
              {!['CONFIRMED', 'RESUB'].includes(fieldDetails?.status) && (
                <Grid item xs={12}>
                  <Paper
                    elevation={10}
                    sx={{
                      width: '100%',
                      margin: '1rem auto'
                    }}
                  >
                    <Button onClick={onAddDocuments} sx={{ margin: '1rem' }}>
                      Add Documents
                    </Button>
                    <Button onClick={onEditRanch}>Edit Ranch</Button>
                  </Paper>
                </Grid>
              )}
            </Grid>
            {renderBody[tabs]}
          </Grid>
        </Grid>
      )}
    </>
  );
};
